/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    fetchTeamUser,
    getAccessType,
    getIndividualUser,
    updateTeamUser,
    saveTeamUser
} from '../../actions/teamActions';
import {
    Box, Typography, TextField, Button, Card, CardContent, Avatar, Chip,
    makeStyles, CircularProgress, Dialog, DialogTitle, DialogContent, IconButton
} from '@material-ui/core';
import { Add, Search, Edit } from '@material-ui/icons';
import { Link } from 'react-router-dom';
import moment from 'moment';
import DashboardHeader from '../includes/dashboardHeader/DashboardHeader';
import DashboardSidebar from '../includes/dashboardSidebar/DashboardSidebar';
import FooterComponent from '../includes/dashboardFooter/FooterComponent';
import CloseIcon from '@material-ui/icons/Close';
import AddTeamUser from './AddTeamUser';
import EditTeamUser from './EditTeamUser';
import { Global } from '../../utils/Env';

const useStyles = makeStyles(() => ({
    root: { display: 'flex' },
    content: { flex: 1, padding: '24px' },

    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '20px',
    },

    heading: {
        fontSize: '23px',
        fontWeight: 700,
        color: '#000000',
    },

    breadcrumb: {
        background: 'transparent',
        padding: '0 0 10px 0',
        marginBottom: '10px',
        display: 'flex',
        listStyle: 'none',
        flexWrap: 'wrap',
    },

    breadcrumbItem: {
        color: '#2f353a',
        fontSize: 14,
        '& a': { color: '#083ac8', textDecoration: 'none' },
        '&:not(:last-child)::after': {
            content: "'/'",
            margin: '0 8px',
            color: '#6c757d',
        },
    },

    searchBox: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
    },

    /* CARD VIEW */
    cardGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
        gap: '16px',
    },

    card: {
        borderRadius: 10,
        border: '1px solid #e0e0e0',
        boxShadow: '0 2px 6px rgba(0,0,0,0.04)',
        transition: 'transform 0.15s ease, box-shadow 0.15s ease',
        '&:hover': {
            transform: 'translateY(-3px)',
            boxShadow: '0 6px 12px rgba(0,0,0,0.1)',
        },
        width: '100%',
    },

    avatar: {
        backgroundColor: '#083ac8',
        color: '#fff',
        width: 46,
        height: 46,
        fontWeight: 600,
        fontSize: 17,
    },

    name: {
        fontSize: 15,
        fontWeight: 600,
        color: '#2f353a',
    },

    subInfo: {
        fontSize: 13,
        color: '#6b7280',
    },

    chip: {
        height: 22,
        fontSize: 11,
        fontWeight: 500,
        borderRadius: 12,
    },

    activeChip: {
        backgroundColor: '#e6f4ea',
        color: '#0b8a43',
    },

    inactiveChip: {
        backgroundColor: '#fdecea',
        color: '#d93025',
    },

    roleChip: {
        backgroundColor: '#f0f3f5',
        color: '#2f353a',
    },

    cardContent: {
        padding: '14px 16px !important',
    },

    cardFooter: {
        marginTop: 6,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },

    btnEdit: {
        backgroundColor: '#083ac8',
        color: '#fff',
        fontSize: 11,
        padding: '4px 8px',
        borderRadius: 6,
        '&:hover': { backgroundColor: '#072ea8' },
    },

    /* TABLE VIEW */
    tableWrapper: {
        width: "100%",
        overflowX: "auto",
        background: "#fff",
        borderRadius: 10,
        border: "1px solid #e0e0e0",
    },

    table: {
        width: "100%",
        borderCollapse: "collapse",
    },

    th: {
        background: "#f8f9fa",
        padding: 10,
        borderBottom: "1px solid #e5e7eb",
        textAlign: "left",
        fontSize: 14,
        fontWeight: 600,
        color: "#374151",
    },

    td: {
        padding: 10,
        borderBottom: "1px solid #f1f1f1",
        fontSize: 14,
    }
}));


export default function ManageTeam() {
    const classes = useStyles();
    const dispatch = useDispatch();
    const teamState = useSelector((state) => state.team_array);
    const { teamData, accessType } = teamState;

    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState('');
    const [openDialog, setOpenDialog] = useState(false);
    const [dialogMode, setDialogMode] = useState('add');
    const [resetData, setResetData] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [viewMode, setViewMode] = useState("card"); // NEW: card/table toggle

    useEffect(() => {
        dispatch(fetchTeamUser());
        dispatch(getAccessType());
        const timer = setTimeout(() => setLoading(false), 1000);
        return () => clearTimeout(timer);
    }, [dispatch]);

    Global.callback.updateTeamUser_onComplete = () => {
        dispatch(fetchTeamUser());
        setResetData(true);
        setOpenDialog(false);
    };

    const handleAddClick = () => {
        setDialogMode('add');
        setOpenDialog(true);
    };

    const handleEditClick = (userId) => {
        setSelectedUserId(userId);
        dispatch(getIndividualUser({ UserDIVATeamID: userId }));
        setDialogMode('edit');
        setOpenDialog(true);
    };

    const filtered = teamData?.filter((u) =>
        `${u.FirstName} ${u.LastName}`.toLowerCase().includes(search.toLowerCase())
    ) || [];


    return (
        <>
            <DashboardHeader />

            <div id="wrapper" className={classes.root}>
                <DashboardSidebar />

                <main id="content-wrapper" className={classes.content}>

                    {/* BREADCRUMB */}
                    <ol className={classes.breadcrumb}>
                        <li className={classes.breadcrumbItem}><Link to="#">Home</Link></li>
                        <li className={classes.breadcrumbItem}><Link to="#">Manage</Link></li>
                        <li className={classes.breadcrumbItem}>Manage AmploFly 4.0 Team</li>
                        <li className={classes.breadcrumbItem} style={{ marginLeft: 'auto' }}>
                            <img src={require('../../common/images/diva-icon.png')} alt="Logo"
                                style={{ height: 22, marginRight: 5 }} />
                            <i style={{ fontStyle: 'italic', color: '#6b7280', fontSize: 13 }}>Powered by Amploglobal</i>
                        </li>
                    </ol>

                    {/* TOOLBAR */}
                    <div className={classes.toolbar}>
                        <Typography className={classes.heading}>
                            Manage AmploFly 4.0 Team
                        </Typography>

                        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>

                            {/* 🔘 TOGGLE VIEW BUTTON */}
                            <Button
                                variant="outlined"
                                color="primary"
                                onClick={() => setViewMode(viewMode === "card" ? "table" : "card")}
                            >
                                {viewMode === "card" ? "Table View" : "Card View"}
                            </Button>

                            {/* SEARCH + ADD USER */}
                            <div className={classes.searchBox}>
                                <TextField
                                    size="small"
                                    style={{ background: 'white' }}
                                    variant="outlined"
                                    placeholder="Search user..."
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                    InputProps={{
                                        startAdornment: <Search fontSize="small" style={{ marginRight: 8 }} />
                                    }}
                                />

                                <Button
                                    variant="contained"
                                    color="primary"
                                    startIcon={<Add />}
                                    style={{ backgroundColor: '#083ac8' }}
                                    onClick={handleAddClick}
                                >
                                    Add User
                                </Button>
                            </div>
                        </div>
                    </div>

                    {/* CONTENT */}
                    {loading ? (
                        <CircularProgress />
                    ) : (

                        <>
                            {/* ----------------------- */}
                            {/* CARD VIEW */}
                            {/* ----------------------- */}
                            {viewMode === "card" && (
                                <div className={classes.cardGrid}>
                                    {filtered.length === 0 ? (
                                        <Typography>No users found.</Typography>
                                    ) : (
                                        filtered.map((user, i) => {
                                            const displayStatus = user.DisableDate ? 'Inactive' : 'Active';
                                            return (
                                                <Card key={i} className={classes.card}>
                                                    <CardContent className={classes.cardContent}>
                                                        <Box display="flex" alignItems="center" mb={1.5}>
                                                            <Avatar className={classes.avatar}>
                                                                {user.FirstName ? user.FirstName.charAt(0).toUpperCase() : 'U'}
                                                            </Avatar>
                                                            <Box ml={2}>
                                                                <Typography className={classes.name}>
                                                                    {user.FirstName} {user.LastName}
                                                                </Typography>
                                                                <Typography className={classes.subInfo}>
                                                                    {user.Email || '—'}
                                                                </Typography>
                                                            </Box>
                                                        </Box>

                                                        <Box mb={1} display="flex" alignItems="center" gap={6}>
                                                            <Chip label={user.UserTypeName} size="small"
                                                                className={`${classes.chip} ${classes.roleChip}`} />

                                                            <Chip label={displayStatus} size="small"
                                                                className={`${classes.chip} ${displayStatus === 'Active'
                                                                    ? classes.activeChip
                                                                    : classes.inactiveChip
                                                                    }`}
                                                            />
                                                        </Box>

                                                        <Box className={classes.cardFooter}>
                                                            <Typography style={{ fontSize: 12, color: '#6b7280' }}>
                                                                Created: {user.CreatedDate
                                                                    ? moment(user.CreatedDate).format('YYYY-MM-DD')
                                                                    : '—'}
                                                            </Typography>

                                                            <Button
                                                                size="small"
                                                                className={classes.btnEdit}
                                                                startIcon={<Edit fontSize="small" />}
                                                                onClick={() => handleEditClick(user.UserDIVATeamID)}
                                                            >
                                                                Edit
                                                            </Button>
                                                        </Box>
                                                    </CardContent>
                                                </Card>
                                            );
                                        })
                                    )}
                                </div>
                            )}

                            {/* ----------------------- */}
                            {/* TABLE VIEW  */}
                            {/* ----------------------- */}
                            {viewMode === "table" && (
                                <div className={classes.tableWrapper}>
                                    <table className={classes.table}>
                                        <thead>
                                            <tr>
                                                <th className={classes.th}>Name</th>
                                                <th className={classes.th}>Email</th>
                                                <th className={classes.th}>User Type</th>
                                                <th className={classes.th}>Status</th>
                                                <th className={classes.th}>Created Date</th>
                                                <th className={classes.th}>Action</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {filtered.length === 0 ? (
                                                <tr><td colSpan="6" className={classes.td}>No users found.</td></tr>
                                            ) : (
                                                filtered.map((user, i) => {
                                                    const displayStatus = user.DisableDate ? 'Inactive' : 'Active';
                                                    return (
                                                        <tr key={i}>
                                                            <td className={classes.td}>
                                                                {user.FirstName} {user.LastName}
                                                            </td>

                                                            <td className={classes.td}>{user.Email || '—'}</td>

                                                            <td className={classes.td}>{user.UserTypeName}</td>

                                                            <td className={classes.td}
                                                                style={{
                                                                    color: displayStatus === "Active" ? "green" : "red",
                                                                    fontWeight: 600
                                                                }}>
                                                                {displayStatus}
                                                            </td>

                                                            <td className={classes.td}>
                                                                {user.CreatedDate
                                                                    ? moment(user.CreatedDate).format('YYYY-MM-DD')
                                                                    : '—'}
                                                            </td>

                                                            <td className={classes.td}>
                                                                <Button
                                                                    size="small"
                                                                    className={classes.btnEdit}
                                                                    startIcon={<Edit fontSize="small" />}
                                                                    onClick={() => handleEditClick(user.UserDIVATeamID)}
                                                                >
                                                                    Edit
                                                                </Button>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            )}

                        </>
                    )}

                </main>
            </div>


            {/* ADD/EDIT USER DIALOG */}
            <Dialog
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                fullWidth
                maxWidth="sm"
                PaperProps={{ style: { borderRadius: 10, padding: '8px 4px' } }}
            >
                <DialogTitle
                    disableTypography
                    style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: 0 }}
                >
                    <Typography variant="h6" style={{ fontWeight: 600, color: '#083ac8', margin: 0 }}>
                        {dialogMode === 'add' ? 'Add New Team Member' : 'Edit Team Member'}
                    </Typography>

                    <IconButton size="small" onClick={() => setOpenDialog(false)}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent>
                    {dialogMode === 'add' ? (
                        <AddTeamUser
                            data={{ accessType }}
                            onClickhandleSaveClick={(payload) => dispatch(saveTeamUser(payload))}
                            resetData={resetData}
                            resetDataChangeHandler={() => setResetData(!resetData)}
                            onClose={() => setOpenDialog(false)}
                        />
                    ) : (
                        <EditTeamUser
                            data={teamState}
                            userId={selectedUserId}
                            onClickhandleUpdateClick={(userObj) => dispatch(updateTeamUser(userObj))}
                            resetData={resetData}
                            resetDataChangeHandler={() => setResetData(!resetData)}
                            onClose={() => setOpenDialog(false)}
                        />
                    )}
                </DialogContent>
            </Dialog>

            <FooterComponent />
        </>
    );
}
